import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { TopDestination } from './TopDestination'
import type { GETTopDestinationsByBannerIdResponse } from '../infrastructure/HTTPMarketingRepository/schemas/banners/:id/destinations'

export const ListOfTopDestinationValidation = z.object({
  list: z.instanceof(TopDestination, { message: 'list is required' }).array(),
})

export class ListOfTopDestination extends Model {
  static create({ list }: z.infer<typeof ListOfTopDestinationValidation>) {
    ListOfTopDestinationValidation.parse({ list })
    return new ListOfTopDestination(list)
  }

  static fromAPI({ json }: { json: GETTopDestinationsByBannerIdResponse }) {
    return ListOfTopDestination.create({
      list: json.destinations.map(destinationJSON =>
        TopDestination.fromAPI({ json: destinationJSON })
      ),
    })
  }

  static empty() {
    return new ListOfTopDestination([])
  }

  static fromJSON(json: ReturnType<ListOfTopDestination['toJSON']>) {
    return ListOfTopDestination.create({
      list: json.list.map(destinationJSON => TopDestination.fromJSON(destinationJSON)),
    })
  }

  constructor(private readonly _list: TopDestination[]) {
    super()
  }

  get list() { return this._list } // prettier-ignore

  toJSON() {
    return { list: this._list.map(item => item.toJSON()) }
  }

  isEmpty() {
    return this._list.length === 0
  }

  at(index: number) {
    return this._list.at(index)
  }

  map(callback: (destination: TopDestination, index: number) => unknown) {
    return this._list.map(callback)
  }
}
